// Types für die Schwangerschafts-Infokarte

export interface HospitalInfo {
  name?: string;
  address?: string;
  phone?: string;
  delivery_phone?: string;
}

export interface GynecologistInfo {
  practice?: string;
  phone?: string;
  emergency_phone?: string;
}

export interface MidwifeInfo {
  name?: string;
  phone?: string;
  on_call_from_ssw?: number;
}

export interface PediatricianInfo {
  practice?: string;
  doctor_name?: string;
  address?: string;
  phone?: string;
}

export interface BabyMedicalData {
  blood_type?: string;
  rhesus_factor?: string;
  allergies?: string;
  notes?: string;
}

export interface MedicalData {
  blood_type?: string;
  rhesus_factor?: string;
  allergies?: string;
  notes?: string;
}

export interface InsuranceInfo {
  provider?: string;
  number?: string;
}

export interface EmergencyContact {
  name: string;
  phone: string;
  relationship: string;
}

export interface PregnancyInfoData {
  hospital?: HospitalInfo;
  gynecologist?: GynecologistInfo;
  midwife?: MidwifeInfo;
  medical_data?: MedicalData;
  insurance?: InsuranceInfo;
  emergency_contacts?: EmergencyContact[];
  // Baby mode specific fields
  pediatrician?: PediatricianInfo;
  baby_medical_data?: BabyMedicalData;
}

export interface PregnancyInfoResponse {
  exists: boolean;
  id?: string;
  data: PregnancyInfoData | null;
  created_at?: string;
  updated_at?: string;
}

// Blutgruppen-Optionen
export const BLOOD_TYPES = ['A', 'B', 'AB', '0'] as const;
export type BloodType = (typeof BLOOD_TYPES)[number];

// Rhesusfaktor-Optionen
export const RHESUS_FACTORS = ['positiv', 'negativ'] as const;
export type RhesusFactor = (typeof RHESUS_FACTORS)[number];

// Beziehungs-Optionen für Notfallkontakte
export const RELATIONSHIPS = [
  'Partner/in',
  'Mutter',
  'Vater',
  'Schwester',
  'Bruder',
  'Freund/in',
  'Schwiegermutter',
  'Schwiegervater',
  'Sonstige/r',
] as const;
export type Relationship = (typeof RELATIONSHIPS)[number];

// Prüfen ob die Infokarte ausgefüllt ist (mindestens ein Feld)
export function hasAnyData(data: PregnancyInfoData | null | undefined): boolean {
  if (!data) return false;

  const hasHospital = !!(data.hospital?.name || data.hospital?.phone);
  const hasGynecologist = !!(data.gynecologist?.practice || data.gynecologist?.phone);
  const hasMidwife = !!(data.midwife?.name || data.midwife?.phone);
  const hasMedical = !!(data.medical_data?.blood_type || data.medical_data?.allergies);
  const hasInsurance = !!(data.insurance?.provider);
  const hasContacts = !!(data.emergency_contacts && data.emergency_contacts.length > 0);
  const hasPediatrician = !!(data.pediatrician?.practice || data.pediatrician?.phone);
  const hasBabyMedical = !!(data.baby_medical_data?.blood_type || data.baby_medical_data?.allergies);

  return hasHospital || hasGynecologist || hasMidwife || hasMedical || hasInsurance || hasContacts || hasPediatrician || hasBabyMedical;
}
